import { makeStyles } from '@mui/styles';
import { Colors } from '../../../../theme/colors';

export const useEntityHistoryEventStyles = makeStyles((theme) => ({
  wrapper: {
    position: 'relative',
    padding: '8px 0'
  },
  row: {
    display: 'flex',
    alignItems: 'flex-start',
    width: '100%',
    position: 'relative',
    zIndex: 2
  },
  icon: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '0 8px 0 0',
    flexShrink: 0,
    position: 'relative',
    zIndex: 2
  },
  content: {
    width: '100%',
    minWidth: 0
  },
  displayName: {
    fontSize: '14px',
    fontWeight: 500,
    color: Colors.darkGray,
    display: 'block'
  },
  timestamp: {
    fontSize: '12px',
    color: Colors.darkGray,
    display: 'block',
    marginTop: '4px'
  },
  bubble: {
    marginTop: '1.4rem',
    backgroundColor: 'white',
    borderRadius: '8px',
    position: 'relative',
    overflow: 'unset',
    width: '65%',
    boxSizing: 'border-box',
    padding: '0 1rem 1rem 1rem',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    },
    '&::before': {
      position: 'absolute',
      content: "''",
      top: '-1rem',
      left: '1rem',
      width: 0,
      height: 0,
      borderLeft: '6px solid transparent',
      borderRight: '6px solid transparent',
      borderBottom: '1rem solid white'
    }
  },
  bubbleTitle: {
    color: Colors.timelineGray,
    fontSize: '12px',
    textTransform: 'uppercase',
    margin: 0,
    padding: '1rem 0 0 0'
  },
  divider: {
    position: 'absolute',
    height: 'calc(100% - (60px - 1.4rem))',
    top: '50px',
    left: '20px',
    zIndex: 1,
    borderLeft: '0.2rem solid rgba(0,0,0,0.2)'
  }
}));
